/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SubscriptionUserControllerToggleAutoRenewMutationResponse,
  SubscriptionUserControllerToggleAutoRenew401,
} from '../../types/SubscriptionUserControllerToggleAutoRenew.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { subscriptionUserToggleAutoRenew } from '../../methods/subscriptionUserToggleAutoRenew.ts';
import { useMutation } from '@tanstack/react-query';

export const subscriptionUserToggleAutoRenewMutationKey = () =>
  [{ url: '/api/user/telegram/subscriptions/toggle-auto-renew' }] as const;

export type SubscriptionUserToggleAutoRenewMutationKey = ReturnType<typeof subscriptionUserToggleAutoRenewMutationKey>;

/**
 * {@link /api/user/telegram/subscriptions/toggle-auto-renew}
 */
export function useSubscriptionUserToggleAutoRenew<TContext>(
  options: {
    mutation?: UseMutationOptions<
      SubscriptionUserControllerToggleAutoRenewMutationResponse,
      ResponseErrorConfig<SubscriptionUserControllerToggleAutoRenew401>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? subscriptionUserToggleAutoRenewMutationKey();

  return useMutation<
    SubscriptionUserControllerToggleAutoRenewMutationResponse,
    ResponseErrorConfig<SubscriptionUserControllerToggleAutoRenew401>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return subscriptionUserToggleAutoRenew(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
